import React, { useState, useEffect } from "react";
import styled from "styled-components";
import CustomModal from "../Generic/CustomModal";
import CustomInput from "../Generic/CustomInput";

const isValidUrl = (url) => /^https:\/\/\S+$/i.test(url.trim());

const WebhookEndpointFormModal = ({ isOpen, onClose, endpointToEdit, eventTypes, onSubmit }) => {
  const [url, setUrl] = useState("");
  const [allEvents, setAllEvents] = useState(true);
  const [selectedEvents, setSelectedEvents] = useState([]);

  useEffect(() => {
    if (!isOpen) return;
    setUrl(endpointToEdit?.url || "");
    setAllEvents(!endpointToEdit?.event_types?.length);
    setSelectedEvents(endpointToEdit?.event_types || []);
  }, [isOpen, endpointToEdit]);

  const toggleEvent = (eventType) => {
    setSelectedEvents((prev) =>
      prev.includes(eventType) ? prev.filter((e) => e !== eventType) : [...prev, eventType]
    );
  };

  const canSubmit = isValidUrl(url) && (allEvents || selectedEvents.length > 0);

  const handleSubmit = () => onSubmit({ url: url.trim(), event_types: allEvents ? [] : selectedEvents });

  return (
    <CustomModal
      isOpen={isOpen}
      onOpenChange={onClose}
      iconType="apiKey"
      iconAlignment="left"
      headerLayout="row"
      title={endpointToEdit ? "Edit Webhook Endpoint" : "Add Webhook Endpoint"}
      subtitle="We'll send a signed POST request to this URL for each selected event."
      titleAlignment="left"
      buttonLayout="row"
      showCloseButton={false}
      autoCloseOnSuccess={true}
      width={600}
      buttons={[
        { text: "Cancel", onClick: onClose, variant: "secondary" },
        {
          text: endpointToEdit ? "Save" : "Add Endpoint",
          action: handleSubmit,
          variant: "primary",
          disabled: !canSubmit,
          successMessage: endpointToEdit ? "Webhook endpoint updated" : "Webhook endpoint added",
        },
      ]}
    >
      <Content>
        <CustomInput
          label="Endpoint URL"
          name="webhook-url"
          placeholder="https://crm.example.com/emotii/webhooks"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          error={url.length > 0 && !isValidUrl(url)}
          errorText="Use a full https:// URL"
        />

        <EventsGroup>
          <Label>Events</Label>
          <CheckboxRow>
            <input type="checkbox" checked={allEvents} onChange={(e) => setAllEvents(e.target.checked)} />
            <span>All events</span>
          </CheckboxRow>
          {!allEvents &&
            eventTypes.map((eventType) => (
              <CheckboxRow key={eventType} data-emotii-exclude>
                <input
                  type="checkbox"
                  checked={selectedEvents.includes(eventType)}
                  onChange={() => toggleEvent(eventType)}
                />
                <Mono>{eventType}</Mono>
              </CheckboxRow>
            ))}
        </EventsGroup>
      </Content>
    </CustomModal>
  );
};

export default WebhookEndpointFormModal;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

const EventsGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Label = styled.span`
  color: #414651;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

const CheckboxRow = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #344054;
  font-size: 14px;
  cursor: pointer;

  input {
    cursor: pointer;
    margin: 0;
  }
`;

const Mono = styled.span`
  font-family: 'Courier New', monospace;
`;
